var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p-panel-input-select',{attrs:{"items":_vm.fontSizes,"item-text":"text","return-object":true},model:{value:(_vm.fontSize),callback:function ($$v) {_vm.fontSize=$$v},expression:"fontSize"}})
}
var staticRenderFns = []

export { render, staticRenderFns }